import { addDependency, addThreewayDependency, isDestructable } from "./utils";
import DestructableObject from "./DestructableObject";

//TODO edg: think of better name
export default class OnDemandEvaluatedMap<K, V, A extends any[] = []> extends DestructableObject {
	private readonly map = new Map<K, V>();

	constructor(private readonly evaluate: (key: K, ...args: A) => V, private readonly persistant = true) {
		super();
	}

	get size(): number {
		return this.map.size;
	}

	has(key: K): boolean {
		return this.map.has(key);
	}

	get(key: K, ...args: A): V {
		if (!this.map.has(key)) {
			const value = this.evaluate(key, ...args);
			this.map.set(key, value);

			const key_is_destructable = isDestructable(key);
			const value_is_destructable = isDestructable(value);
			if (key_is_destructable && value_is_destructable) {
				addThreewayDependency(this, key, value, () => this.delete(key));
			} else if (key_is_destructable) {
				addDependency(this, key, () => this.delete(key));
			} else if (value_is_destructable) {
				addDependency(this, value, () => this.delete(key));
			}
			return value;
		} else {
			return this.map.get(key)!;
		}
	}

	delete(key: K): boolean {
		const result = this.map.delete(key);
		if (!this.persistant && this.map.size === 0) {
			this.destroy();
		}
		return result;
	}

	entries(): IterableIterator<[K, V]> {
		return this.map.entries();
	}

	[Symbol.iterator](): IterableIterator<[K, V]> {
		return this.map[Symbol.iterator]();
	}

	forEach(callbackfn: (value: V, key: K, map: Map<K, V>) => void, thisArg?: any): void {
		return this.map.forEach(callbackfn, thisArg);
	}

	keys(): IterableIterator<K> {
		return this.map.keys();
	}

	values(): IterableIterator<V> {
		return this.map.values();
	}

	clear(): void {
		this.map.clear();
		if (!this.destroyed && !this.persistant) {
			this.destroy();
		}
	}

	destroy(): void {
		this.map.clear();
		super.destroy();
	}
}
